/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_CancelingInputs */

const en_settings_billing_canceling = /** @type {(inputs: Settings_Billing_CancelingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canceling...`)
};

const zh_settings_billing_canceling = /** @type {(inputs: Settings_Billing_CancelingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消中...`)
};

/**
* | output |
* | --- |
* | "Canceling..." |
*
* @param {Settings_Billing_CancelingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_canceling = /** @type {((inputs?: Settings_Billing_CancelingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_CancelingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_canceling(inputs)
	return zh_settings_billing_canceling(inputs)
});
export { settings_billing_canceling as "settings.billing.canceling" }